document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-m-newsletter-signup]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    if (section.dataset.mNewsletterSignupInit === 'true') return;
    section.dataset.mNewsletterSignupInit = 'true';

    var inputs = section.querySelectorAll('.m-newsletter-signup__input');
    var form = section.querySelector('.m-newsletter-signup__form');
    var emailInput = section.querySelector('.m-newsletter-signup__input[type="email"]');
    var submitButton = section.querySelector('.m-newsletter-signup__button');
    var clientMessage = section.querySelector('[data-m-newsletter-client-message]');

    var klaviyoEnabled = section.dataset.mNewsletterKlaviyoEnabled === 'true';
    var klaviyoListId = (section.dataset.mNewsletterKlaviyoListId || '').trim();
    var klaviyoSource = (section.dataset.mNewsletterKlaviyoSource || '').trim();
    var successMessage = (section.dataset.mNewsletterSuccessMessage || 'Thanks for subscribing.').trim();
    var errorMessage = (section.dataset.mNewsletterErrorMessage || 'Something went wrong. Please try again.').trim();

    function syncState(input) {
      if (!input) return;

      if (input.value && input.value.trim() !== '') {
        input.classList.add('has-value');
      } else {
        input.classList.remove('has-value');
      }
    }

    function showClientMessage(type, message) {
      if (!clientMessage) return;

      clientMessage.hidden = false;
      clientMessage.classList.remove('m-newsletter-signup__message--success', 'm-newsletter-signup__message--error');
      clientMessage.classList.add(type === 'success' ? 'm-newsletter-signup__message--success' : 'm-newsletter-signup__message--error');
      clientMessage.textContent = message;
    }

    function hideClientMessage() {
      if (!clientMessage) return;

      clientMessage.hidden = true;
      clientMessage.textContent = '';
      clientMessage.classList.remove('m-newsletter-signup__message--success', 'm-newsletter-signup__message--error');
    }

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        syncState(input);
      });

      input.addEventListener('blur', function () {
        syncState(input);
      });

      syncState(input);
    });

    if (!form || !emailInput || !submitButton || !klaviyoEnabled || !klaviyoListId) {
      return;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      hideClientMessage();

      var email = emailInput.value ? emailInput.value.trim() : '';

      if (!email) {
        showClientMessage('error', 'Please enter your email address.');
        emailInput.focus();
        return;
      }

      if (!emailInput.checkValidity()) {
        showClientMessage('error', 'Please enter a valid email address.');
        emailInput.focus();
        return;
      }

      submitButton.disabled = true;
      submitButton.classList.add('is-loading');

      var payload = new URLSearchParams();
      payload.append('g', klaviyoListId);
      payload.append('email', email);

      if (klaviyoSource) {
        payload.append('$source', klaviyoSource);
      }

      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json'
        },
        body: payload.toString()
      })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return null;
            })
            .then(function (data) {
              return {
                ok: response.ok,
                data: data
              };
            });
        })
        .then(function (result) {
          var data = result.data || {};
          var msg = typeof data.msg === 'string' ? data.msg : '';
          var apiError = '';

          if (Array.isArray(data.errors) && data.errors.length) {
            apiError = data.errors[0];
          } else if (typeof data.errors === 'string') {
            apiError = data.errors;
          }

          var isSuccess =
            result.ok &&
            (
              data.success === true ||
              (msg && /success|already|subscribed/i.test(msg))
            ) &&
            !apiError;

          if (!isSuccess) {
            throw new Error(apiError || msg || errorMessage);
          }

          form.reset();
          inputs.forEach(function (input) {
            syncState(input);
          });

          showClientMessage('success', successMessage);
        })
        .catch(function (error) {
          showClientMessage('error', error && error.message ? error.message : errorMessage);
        })
        .finally(function () {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        });
    });
  });
});